export default name => (name || '').substr(0, 3) === 'cf_';
